export class DomainEventSubscriptions {
    #listeners = new Set();
    #publishing = false;
    get publishing() {
        return this.#publishing;
    }
    subscribe(listener) {
        this.#listeners.add(listener);
        return () => this.#listeners.delete(listener);
    }
    publish(events) {
        this.#publishing = true;
        try {
            for (const listener of this.#listeners) {
                try {
                    listener(events);
                }
                catch {
                    // Event observers cannot invalidate an already committed transaction.
                }
            }
        }
        finally {
            this.#publishing = false;
        }
    }
}
//# sourceMappingURL=subscriptions.js.map